/* eslint-disable  max-lines*/
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
/* eslint-disable complexity */
/* eslint-disable max-statements */

ACC.changePassword = {
  checkStrength: function(password) { // NOSONAR
    /* eslint-enable complexity */
    var strength = 0,
        textWarning = 'ph-text-warning',
        passwordWarning = 'ph-password_progress__bar--warning',
        successText = 'ph-text-success',
        veryWeakText = $('#veryWeakText').val(),
        weakText = $('#weakText').val(),
        fairText = $('#fairText').val(),
        veryStrongText = $('#veryStrongText').val(),
        strPasswordentrysuccess = 'ph-passwordentrysuccess',
        strPassStrength = 'password-strength1',
        strParentCombo = 'cboxLoadedContent, #ph-resetPass',
        strComboReset = 'ph-icon-cross ph-reset-color',
        strReset = 'ph-reset-color',
        strPassmatch = '.ph-password-matches',
        strBorder = 'border',
        strRedoptionborder = 'ph-redoption' + strBorder,
        strIconCheckmark = 'ph-icon-checkmark',
        strProfileCheckNewPass = 'profile\\.checkNewPassword',
        sterPassmatchi = '.ph-password-matches i',
        strPassStrengthFive = 'password-strength5',
        strDanger = 'ph-text-danger',
        newPassid = 'profile-newPassword';

    if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
      strength = strength + 1;
      $('.ph-low-upper-case i')
        .removeClass(strComboReset)
        .addClass(strIconCheckmark);
      $('.ph-low-upper-case').next().removeClass(strReset);
    } else {
      $('.ph-low-upper-case i')
        .addClass(strComboReset)
        .removeClass(strIconCheckmark);
      $('.ph-low-upper-case').next().addClass(strReset);
    }

    if (password.match(/(\d)/)) {
      strength = strength + 1;
      $('.ph-one-number i')
        .removeClass(strComboReset)
        .addClass(strIconCheckmark);
      $('.ph-one-number').next().removeClass(strReset);
    } else {
      $('.ph-one-number i')
        .addClass(strComboReset)
        .removeClass(strIconCheckmark);
      $('.ph-one-number').next().addClass(strReset);
    }

    /* eslint-disable no-useless-escape */
    if (password.match(/([!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`])/)) {
      strength = strength + 1;
      $('.ph-one-special-char i')
        .removeClass(strComboReset)
        .addClass(strIconCheckmark);
      $('.ph-one-special-char').next().removeClass(strReset);
    } else {
      $('.ph-one-special-char i')
        .addClass(strComboReset)
        .removeClass(strIconCheckmark);
      $('.ph-one-special-char').next().addClass(strReset);
    }

    /* eslint-enable no-useless-escape */
    if (password.length > 7) {
      strength = strength + 1;
      $('.ph-eight-character i')
        .removeClass(strComboReset)
        .addClass(strIconCheckmark);
      $('.ph-eight-character').next().removeClass(strReset);
    } else {
      $('.ph-eight-character i')
        .addClass(strComboReset)
        .removeClass(strIconCheckmark);
      $('.ph-eight-character').next().addClass(strReset);
    }

    if ($('#' + newPassid).val() === $('#profile\\.checkNewPassword').val() && $('#' + newPassid).val() !== '') {
      strength = strength + 1;
      $(sterPassmatchi)
        .removeClass(strComboReset)
        .addClass(strIconCheckmark);
      $(strPassmatch).next().removeClass(strReset);
    } else {
      $(sterPassmatchi)
        .addClass(strComboReset)
        .removeClass(strIconCheckmark);
      $('#password-strength5').css('width', '0%');
      $(strPassmatch).next().addClass(strReset);
    }

    if (strength === 0 && password === '') {
      $('#result')
        .removeClass(strDanger)
        .text('');
      $('#' + strParentCombo).find('#' + strPassStrength).css('width', '0%');
      $('#' + strParentCombo).find('#password-strength2').css('width', '0%');
      $('#' + strParentCombo).find('#password-strength3').css('width', '0%');
      $('#' + strParentCombo).find('#password-strength4').css('width', '0%');
      $('#' + strParentCombo).find('#' + strPassStrengthFive).css('width', '0%');
      $('#' + strParentCombo).find('#' + strProfileCheckNewPass).parents().eq(2).find('.' + strPasswordentrysuccess).addClass('hidden');
      $('#' + strParentCombo).find('#' + newPassid).parent().removeClass(strRedoptionborder);
      $('#' + strParentCombo).find('#' + newPassid).parents().eq(2).find('.' + strPasswordentrysuccess).addClass('hidden');

      return false;
    } else if (strength < 2) {
      $('#' + strParentCombo).find('#result').removeClass().addClass('ph-resetpassword-result');
      $('#' + strParentCombo).find('#' + strPassStrength).addClass('ph-password_progress__bar--danger ');
      $('#' + strParentCombo).find('#result')
        .addClass(strDanger)
        .text(veryWeakText);
      $('#' + strParentCombo).find('#' + strPassStrength).css('width', '100%');
      $('#' + strParentCombo).find('#password-strength2').css('width', '0%');
      $('#' + strParentCombo).find('#password-strength3').css('width', '0%');
      $('#' + strParentCombo).find('#password-strength4').css('width', '0%');
      $('#' + strParentCombo).find('#' + strPassStrengthFive).css('width', '0%');
      $('#' + strParentCombo).find('#' + newPassid).parent().addClass(strRedoptionborder);
      $('#' + strParentCombo).find('#' + strProfileCheckNewPass).parents().eq(2).find('.' + strPasswordentrysuccess).addClass('hidden');

      return false;
    } else if (strength === 2) {
      $('#' + strParentCombo).find('.password-strength2').addClass(passwordWarning);
      $('#' + strParentCombo).find('#result')
        .addClass(strDanger)
        .removeClass(textWarning)
        .removeClass(successText)
        .text(weakText);
      $('#' + strParentCombo).find('.password-strength2').css('width', '100%');
      $('#' + strParentCombo).find('.password-strength3').css('width', '0%');
      $('#' + strParentCombo).find('.password-strength4').css('width', '0%');
      $('#' + strParentCombo).find('#' + strPassStrengthFive).css('width', '0%');
      $('#' + strParentCombo).find('#' + newPassid).parent().addClass(strRedoptionborder);
      $('#' + strParentCombo).find('#' + strProfileCheckNewPass).parents().eq(2).find('.' + strPasswordentrysuccess).addClass('hidden');

      return false;
    } else if (strength === 3) {
      $('#' + strParentCombo).find('.password-strength3').addClass(passwordWarning);
      $('#' + strParentCombo).find('#result')
        .addClass(textWarning)
        .removeClass(strDanger)
        .removeClass(successText)
        .text(fairText);
      $('#' + strParentCombo).find('.password-strength_2').css('width', '100%');
      $('#' + strParentCombo).find('.password-strength_3').css('width', '100%');
      $('#' + strParentCombo).find('.password-strength4').css('width', '0%');
      $('#' + strParentCombo).find('#' + strPassStrengthFive).css('width', '0%');
      $('#' + strParentCombo).find('#' + strProfileCheckNewPass).parents().eq(2).find('.' + strPasswordentrysuccess).addClass('hidden');
      $('#' + strParentCombo).find('#' + newPassid).parent().addClass(strRedoptionborder);
      $('#' + strParentCombo).find('#' + newPassid).parents().eq(2).find('.' + strPasswordentrysuccess).addClass('hidden');


      return false;
    } else if (strength === 4) {
      $('#' + strParentCombo).find('#result').removeClass().addClass('ph-resetpassword-result');
      $('#' + strParentCombo).find('#password-strength').removeClass(passwordWarning);
      $('#' + strParentCombo).find('.password-strength_4').addClass('ph-password_progress__bar--success');
      $('#' + strParentCombo).find('#result')
        .addClass(successText)
        .removeClass(strDanger)
        .removeClass(textWarning)
        .text(veryStrongText);
      $('#' + strParentCombo).find('.password-strength_3').css('width', '100%');
      $('#' + strParentCombo).find('.password-strength_4').css('width', '100%');
      $('#' + strParentCombo).find('#' + strPassStrengthFive).css('width', '100%');
      $('#' + strParentCombo).find('#' + newPassid).parent().removeClass(strRedoptionborder);
      $('#' + strParentCombo).find('#' + newPassid).parents().eq(2).find('.' + strPasswordentrysuccess).removeClass('hidden');
      $('#' + strParentCombo).find('#' + strProfileCheckNewPass).parents().eq(2).find('.' + strPasswordentrysuccess).addClass('hidden');


      return false;
    } else if (strength === 5) {
      $('#' + strParentCombo).find('#result').removeClass().addClass('ph-setpassword-result');
      $('#' + strParentCombo).find('#password-strength').removeClass(passwordWarning);
      $('#' + strParentCombo).find('#' + strPassStrengthFive).addClass('ph-password_progress__bar--success');
      $('#' + strParentCombo).find('#result')
        .addClass(successText)
        .removeClass(textWarning)
        .text(veryStrongText);
      $('#' + strParentCombo).find('ph-password-strength4').css('width', '100%');
      $('#' + strParentCombo).find('#' + strPassStrengthFive).css('width', '100%');
      $('#' + strParentCombo).find('#' + newPassid).parent().removeClass(strRedoptionborder);
      $('#' + strParentCombo).find('#' + newPassid).parents().eq(2).find('.' + strPasswordentrysuccess).removeClass('hidden');
      $('#' + strParentCombo).find('#' + strProfileCheckNewPass).parents().eq(2).find('.' + strPasswordentrysuccess).removeClass('hidden');


      return 'Strong';
    }

    return false;
  }
};

$(document).ready(function() {
  var strCurrPassInp = '.ph-currentpassword__input',
      strCboxUpdatePass = '#cboxLoadedContent .ph-update-password-button',
      strCboxCurrentPass = '#cboxLoadedContent .ph-currentpassword__emptyvalue',
      strDisable = 'ph-disable-button',
      strRedoptionborder = 'ph-redoptionborder';

  $(document).on('keyup', '#profile-newPassword', function() {
    var updatedPassword = $(this).val(),
        newPassword = '',
        currentPassword = '',
        repeatNewPassword = '',
        currprofilepassword = 'profile-currentPassword',
        repeatprofpassword = 'profile-checkNewPassword',
        updatebtn = 'update-password-button',
        disbtn = 'disable-button',
        profNewPassword = 'file-newPassword';

    $('#pro' + profNewPassword).val(updatedPassword);

    newPassword = $('#pro' + profNewPassword).val();
    currentPassword = $('#' + currprofilepassword).val();
    repeatNewPassword = $('#' + repeatprofpassword).val();

    ACC.changePassword.checkStrength(newPassword);

    if (newPassword && repeatNewPassword === newPassword && currentPassword !== '') {
      $('.ph-' + updatebtn).removeClass('ph-' + disbtn);
    } else if (newPassword === '') {
      $('.ph-resetpassword-result').html(' ');
    } else {
      $('.ph-' + updatebtn).addClass('ph-' + disbtn);
    }

    $.colorbox.resize();
  });

  $(document).on('blur', '#profile-newPassword, #profile-checkNewPassword, #profile-currentPassword', function() {
    document.activeElement.blur();
  });

  $(document).on('keyup', '#profile-checkNewPassword', function() {
    var updatedPassword = $(this).val(),
        newPassword = '',
        currentPassword = '',
        repeatNewPassword = '',
        repeatprofpassword = 'profile-checkNewPassword',
        crossCount = '#ph-resetPass .ph-listofsteps .ph-icon-cross',
        strComboReset = 'ph-icon-cross ph-reset-color',
        strReset = 'ph-reset-color',
        strPassmatch = '.ph-password-matches',
        strIconCheckmark = 'ph-icon-checkmark',
        sterPassmatchi = '.ph-password-matches i',
        profNewPassword = 'newPassword',
        currprofilepasswordpop = '',
        currentPasswordprofilepop = '';

    $('#profile-checkNewPassword').val(updatedPassword);

    newPassword = $('#profile-' + profNewPassword).val();
    currentPassword = $('#profile-currentPassword').val();
    repeatNewPassword = $('#' + repeatprofpassword).val();

    ACC.changePassword.checkStrength(newPassword);

    if (repeatNewPassword === newPassword) {
      $('.ph-repetpwcheckmark').removeClass('hidden');
      $(sterPassmatchi).removeClass(strComboReset).addClass(strIconCheckmark);
      $(strPassmatch).next().removeClass(strReset);
    } else {
      $('.ph-repetpwcheckmark').addClass('hidden');
      $(sterPassmatchi).addClass(strComboReset).removeClass(strIconCheckmark);
      $(strPassmatch).next().addClass(strReset);
    }

    if (newPassword && repeatNewPassword === newPassword && currentPassword !== '') {
      $(sterPassmatchi).removeClass(strComboReset).addClass(strIconCheckmark);
      $(strPassmatch).next().removeClass(strReset);
    }

    if ($('#cboxLoadedContent').length > 0) {
      crossCount = '#cboxLoadedContent .ph-listofsteps .ph-icon-cross';
    }

    if ($(crossCount).length === 0) {
      currprofilepasswordpop = '#cboxLoadedContent #profile-currentPassword';
      currentPasswordprofilepop = $(currprofilepasswordpop).val();

      if (currentPasswordprofilepop === '') {
        $(strCboxUpdatePass).addClass(strDisable);
        $(strCboxCurrentPass).removeClass('hidden');
        $(strCurrPassInp).parent().addClass(strRedoptionborder);
      } else {
        $(strCboxUpdatePass).removeClass(strDisable);
        $(strCboxCurrentPass).addClass('hidden');
        $(strCurrPassInp).parent().removeClass(strRedoptionborder);
      }

      $('.ph-resetbutton').removeClass(strDisable);
    } else {
      $('.ph-resetbutton').addClass(strDisable);
      $('.ph-update-password-button').addClass(strDisable);
    }

    $.colorbox.resize();
  });
});

$(document).ready(function() {
  var currprofilepassword = '#profile-currentPassword',
      strPasswordentrysuccess = 'ph-passwordentrysuccess',
      strCurrPassInp = '.ph-currentpassword__input',
      strCboxUpdatePass = '#cboxLoadedContent .ph-update-password-button',
      strCboxCurrentPass = '#cboxLoadedContent .ph-currentpassword__emptyvalue',
      strDisable = 'ph-disable-button',
      strRedoptionborder = 'ph-redoptionborder';


  $(document).on('click', '.ph-success-closebtn', function() {
    $('.ph-information_message').addClass('hidden');
  });

  $(document).on('keyup', currprofilepassword, function() {
    var updatedPassword = $(this).val(),
        newprofilePassword = 'newPassword',
        newPassword = $('#profile-' + newprofilePassword).val(),
        currentPassword = $(currprofilepassword).val(),
        crossCount = '#cboxLoadedContent .ph-listofsteps .ph-icon-cross';

    $(currprofilepassword).val(updatedPassword);

    if (updatedPassword === '') {
      if ($(currprofilepassword).parents().eq(3).find('.ph-form_field_error').length > 0) {
        $(currprofilepassword).parents().eq(3).find('.' + strPasswordentrysuccess).addClass('hidden');
      } else {
        $(currprofilepassword).parents().eq(2).find('.' + strPasswordentrysuccess).addClass('hidden');
        $(strCboxUpdatePass).addClass(strDisable);
        $(strCboxCurrentPass).removeClass('hidden');
        $(strCurrPassInp).parent().addClass(strRedoptionborder);
      }
    } else if ($(currprofilepassword).parents().eq(3).find('.ph-form_field_error').length > 0) {
      $(currprofilepassword).parents().eq(3).find('.' + strPasswordentrysuccess).removeClass('hidden');
      $(currprofilepassword).parents().eq(3).find('.' + strPasswordentrysuccess).addClass('ph-errorcurrentpassword');
    } else {
      $(currprofilepassword).parents().eq(2).find('.' + strPasswordentrysuccess).removeClass('hidden');
      $(currprofilepassword).parents().eq(3).find('.' + strPasswordentrysuccess).removeClass('ph-errorcurrentpassword');
      $(strCboxCurrentPass).addClass('hidden');
      $(strCurrPassInp).parent().removeClass(strRedoptionborder);

      if ($(crossCount).length === 0) {
        $(strCboxUpdatePass).removeClass(strDisable);
      }
    }

    if (currentPassword === newPassword && currentPassword !== '') {
      $('.ph-current-password-same').addClass('ph-show');
    } else {
      $('.ph-current-password-same').removeClass('ph-show');
    }

    $.colorbox.resize();
  });

  $(document).on('click', '#update-password', function() {
    var $form = $('#changePasswordForm');

    $.ajax({
      url: ACC.config.encodedContextPath + '/my-account/update-password',
      type: 'POST',
      data: $form.serialize(),
      datatype: 'json',
      success: function(result) {
        if (result === 'profile.currentPassword.invalid') {
          $(strCurrPassInp).addClass('ph-form_field_error');
          $('.ph-currentpassword__emptyvalue').removeClass('hidden');
          $('.ph-currententry').addClass('hidden');
          $(strCurrPassInp).parent().addClass(strRedoptionborder);
          $.colorbox.resize();
        } else if (result === 'updatePwd.pwd.invalid') {
          $('.ph-newpasswordinput').addClass('ph-form_field_error');
          $('.ph-newpassword__emptyvalue').removeClass('hidden');
          $.colorbox.resize();
        } else {
          $('.ph-information_message').removeClass('hidden');
          $.colorbox.close();
        }
      },
      error: function() {
        $('.ph-myprofile__changepasswordpopup').removeClass('hidden');
      }
    });
  });
});

/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
/* eslint-enable max-lines*/
/* eslint-enable max-statements */
